var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.8357 20.7922C-0.272951 19.5609 -0.173538 17.664 1.05775 16.5554L17.9427 1.35207C19.174 0.243422 21.0709 0.342836 22.1796 1.57412L37.3829 18.4591C38.4915 19.6904 38.3921 21.5873 37.1608 22.6959L20.2758 37.8992C19.0445 39.0079 17.1477 38.9085 16.039 37.6772L0.8357 20.7922Z",
    fill: "#024547"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.dfaf4867aefe1bc96ee2771b7f451d55.svg";
export { ForwardRef as ReactComponent };